import { PropTypes } from 'react-desc';

var textProps = {
  containerProps: PropTypes.object.description('Set of Properties attached to the main container'),
  className: PropTypes.string.description('css class'),
  style: PropTypes.object.description('css style'),
  text: PropTypes.string.description('Text to display').isRequired,
  maxCharacters: PropTypes.number.description('Maximum amount of charachters allowed'),
  maxWidth: PropTypes.string.description('Maximum width allowed'),
  textEllipsis: PropTypes.bool.description('Whether to show ellipsis or not'),
  textAlignment: PropTypes.oneOf(['left', 'center', 'right']).description('Text alignement'),
  wordBreak: PropTypes.bool.description('Whether to break the line or not')
};

export { textProps };
//# sourceMappingURL=props.js.map
